export const PRE_SELECTED_SEGMENT_VALUE = 'PI';
